function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "cart",
    d: "M3566.39 5322.289a2.72 2.72 0 1 1 2.72 2.611 2.673 2.673 0 0 1-2.72-2.611zm1.09 0a1.631 1.631 0 1 0 1.63-1.568 1.6 1.6 0 0 0-1.63 1.568zm-11.96 0a2.72 2.72 0 1 1 2.72 2.611 2.669 2.669 0 0 1-2.719-2.611zm1.09 0a1.632 1.632 0 1 0 1.63-1.568 1.6 1.6 0 0 0-1.63 1.568zm2.13-3.656a3.786 3.786 0 0 1-3.73-2.944l-2.65-12.74h-2.815a.525.525 0 1 1 0-1.049h3.26a.536.536 0 0 1 .53.419l.565 2.717h19.555a.533.533 0 0 1 .545.524.294.294 0 0 1-.005.067l-.85 6.532a2.687 2.687 0 0 1-2.7 2.29h-14.59l.215 1.034a2.7 2.7 0 0 0 2.665 2.1h12.545a.525.525 0 1 1 0 1.048zm-3.1-5.233h14.81a1.617 1.617 0 0 0 1.62-1.375l.771-5.945h-18.72z",
    transform: "translate(-3549 -5301.899)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.6fa0fea9.svg";
export { ForwardRef as ReactComponent };